import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

const SESSION_KEY = "toconline_sync_session";

/**
 * Triggers the full TOConline verification pipeline (token → sales →
 * purchases → receipts → payment reconciliation) whenever an admin /
 * super_admin loads the app, at most once per browser session per day.
 * pg_cron (06:00 and 13:00) remains the scheduled source of truth.
 */
export function useDailyTOConlineSync() {
  const { isAdmin, user } = useAuth();

  useEffect(() => {
    if (!user || !isAdmin) return;

    const today = new Date().toISOString().slice(0, 10);
    const marker = `${user.id}:${today}`;
    try {
      if (sessionStorage.getItem(SESSION_KEY) === marker) return;
      sessionStorage.setItem(SESSION_KEY, marker);
    } catch { /* ignore */ }

    // No `force`: the edge function skips if it already ran successfully today.
    supabase.functions
      .invoke("toconline-daily-sync", { body: { source: "app" } })
      .catch((e) => console.warn("[toconline-daily-sync] skipped:", e?.message || e));
  }, [user, isAdmin]);
}
